import React, {useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import InputMask from "react-input-mask";
import {useAuthStore, useRegister} from "../stores/authStore";

const SignPage = () => {
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [errors, setErrors] = useState({});
    const { register, loading, error } = useRegister();

    const validate = () => {
        let newErrors = {};

        // Имя
        if (!firstName) {
            newErrors.firstName = "Введите имя";
        } else if (firstName.length < 5) {
            newErrors.firstName = "Имя должно быть не меньше 5 символов";
        }

        // Фамилия
        if (!lastName) {
            newErrors.lastName = "Введите фамилию";
        } else if (lastName.length < 5) {
            newErrors.lastName = "Фамилия должна быть не меньше 5 символов";
        }

        // Email
        if (!email) {
            newErrors.email = "Введите email";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Неверный формат email";
        }

        // Телефон (должен быть заполнен полностью)
        const rawPhone = phone.replace(/\D/g, "");
        if (!phone) {
            newErrors.phone = "Введите номер телефона";
        } else if (rawPhone.length !== 12) {
            newErrors.phone = "Неверный формат номера телефона";
        }

        // Пароль
        if (!password) {
            newErrors.password = "Введите пароль";
        } else if (password.length < 6) {
            newErrors.password = "Пароль должен быть не менее 6 символов";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const rawPhone = phone.replace(/\D/g, "");
        const formattedPhone = `+${rawPhone}`;

        const success = await register({
            first_name: firstName,
            last_name: lastName,
            email,
            phone: formattedPhone,
            password,
        });

        if (success) {
            navigate("/detail/create/");
        }
    };


    const ErrorText = ({name}) =>
        errors[name] ? (
            <p className="text-xs text-red-600 mt-1">{errors[name]}</p>
        ) : null;

    return (
        <div style={{backgroundImage: `url(https://live.staticflickr.com/65535/48971115011_afe9ae7b26_o.jpg)`}} className={'relative z-20 bg-cover flex items-center min-h-[100vh]'}>
            <div className="md:w-2/5 mx-auto">
                <div className="flex items-center justify-center rounded-2xl bg-white/45 backdrop-blur-md relative overflow-hidden">
                    <div className="px-10 py-4 md:p-8 rounded-lg shadow-md w-full">
                        <h2 className="md:text-2xl text-xl font-semibold text-black/70 mb-2 md:mb-6">Регистрация</h2>
                        <form onSubmit={handleSubmit} className="md:space-y-4 space-y-1">
                            <div>
                                <label className="block text-black/70 text-sm mb-1">Имя</label>
                                <input
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    type="text"
                                    className="w-full bg-white/30 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="firstName"/>
                            </div>
                            <div>
                                <label className="block text-black/70 text-sm mb-1">Фамилия</label>
                                <input
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    type="text"
                                    className="w-full bg-white/30 border text-black/70 rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="lastName"/>
                            </div>
                            <div>
                                <label htmlFor="email" className="text-black/70 block text-sm mb-1">Email</label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    id="email"
                                    className="w-full bg-white/30 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="email"/>
                            </div>
                            <div>
                                <label className="text-black/70 block text-sm mb-1">Номер телефона</label>
                                <InputMask
                                    mask="+996 (000) 00-00-00"
                                    maskChar={null}
                                    formatChars={{ "0": "[0-9]" }}
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                >
                                    {(inputProps) => (
                                        <input
                                            {...inputProps}
                                            type="tel"
                                            className="text-black/70 bg-white/30 md:text-base text-sm w-full font-bold border p-2 rounded-lg focus:outline-none focus:shadow-md"
                                            placeholder="+996 (___) __-__-__"
                                        />
                                    )}
                                </InputMask>
                                <ErrorText name="phone"/>
                            </div>
                            <div>
                                <label htmlFor="password" className="text-black/70 block text-sm mb-1">Password</label>
                                <input
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type="password"
                                    id="password"
                                    className="w-full border text-black/70 bg-white/30 rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="password"/>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-black/60 duration-300 text-white py-2 rounded-lg hover:bg-black transition"
                            >
                                {loading ? "Регистрация..." : "Зарегистрироваться"}
                            </button>
                            {error && <p className="text-red-600 text-sm mt-2">{error.detail}</p>}
                        </form>

                        <div className="mt-4 text-center">
                            <span className="text-sm font-semibold text-black/30">
                                Если у вас есть аккаунт.
                            </span>
                            <Link to={'/detail/login/'} className="hover:text-black text-black/70 hover:underline block">
                                Войти
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default SignPage;
